import { NgModule } from '@angular/core';
import * as HostApiServiceProxies from './service-proxies-host';

@NgModule({
    providers: [
        HostApiServiceProxies.MasterFormulaServiceProxy
    ]
})
export class ServiceProxyHostModule { }